import { useEffect, useRef, useCallback } from "react";

function useEventCallback(fn, dependencies) {
    const ref = useRef(() => {
      throw new Error('Cannot call an event handler while rendering.');
    });
  
    useEffect(() => {
      ref.current = fn;
    }, [fn, ...dependencies]);
  
    return useCallback((...params) => {
      const fn = ref.current;
      return fn(...params);
    }, [ref]);
  }
  export default useEventCallback